<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    :isConfirm="isConfirm"
    :width="width"
    append-to-body
  >
    <div slot="content">
      <el-card shadow="never">
        <div>
          <el-table
            border
            hightlight-current-row
            style="width:100%"
            :header-cell-class-name="headerRow"
            :data="listData"
            :max-height="tableMaxHeight()"
            v-loading="isloading"
          >
            <el-table-column
              type="index"
              label="序号"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="Name"
              label="姓名"
              sortable
            ></el-table-column>
            <el-table-column
              prop="Sex"
              label="性别"
              sortable
              width="80"
              :formatter="Sex"
            ></el-table-column>
            <el-table-column
              prop="IdentityCard"
              label="身份证号码"
              sortable
              width="180"
              align="right"
            ></el-table-column>
            <el-table-column
              prop="Phone"
              label="联系电话"
              sortable
              width="120"
              align="right"
            ></el-table-column>
          </el-table>
        </div>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </el-card>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import md5 from "js-md5";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    applyId: {
      type: String,
      default: ""
    },
    formTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      headerRow: "header-row",
      isConfirm: false,
      isdisabled: false,
      isloading: false,
      width: "60%",

      total: 0,
      currentPage: 1,
      pageSize: 15,
      type: 0,
      listData: []
    };
  },
  mounted() {
    this.loadData();
  },
  components: {
    OfDialog,
    OfPagination
  },
  computed: {},
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    //改变分页大小
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //初始化数据
    loadData() {
      let params={
        pageIndex:this.currentPage,
        pageSize:this.pageSize,
        ApplyId:this.applyId
      }
      api.QueryPersonalTrainByApplyId(params).then(rep => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.listData = rep.data.Data.rows;
        }
      });
    },
    Sex(rowData) {
      return rowData.Sex == 0 ? "女" : "男";
    }
  }
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload-list__item-delete {
  display: none !important;
}
.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
}
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--default {
  display: none;
}
</style>

<style>
.hide .el-upload--fileList {
  display: none;
}
</style>
